import { Action } from "@ngrx/store";
import {
  CentreActionTypes,
  DigLitSelfAssessmentActionTypes,
  EditLearnerActionTypes,
  LearnerActionTypes,
  LearnerOfflineActivityTypes,
  LearningPlanActionTypes,
  LearningRecordTabActionTypes,
  NavigationStateActionTypes,
  OrganisationActionTypes,
  SkillsCheckTabActionTypes,
  StoreActionTypes,
  StoreConstants,
  TutorEditActionTypes,
  UserProfileActionTypes,
} from "../constants/StoreConstants";
import { StoreState } from "./_store.state";

export function storeStorageReducer<T extends Action>(
  reducer: (state: any, action: T) => any
): (state: StoreState, action: T) => any {
  return (state: StoreState, action: T) => {
    if (action.type === StoreActionTypes.ClearState) {
      onStoreUpdate(StoreConstants.INITIAL_STATE);
    }
    if (action.type === StoreActionTypes.SetCourseId) {
      const courseId: number = action[StoreConstants.COURSE_ID];
      const store = onStoreInit();

      if (courseId === store.courseId) {
        return reducer(store, action);
      } else {
        onStoreUpdate(StoreConstants.INITIAL_STATE);
        return reducer(StoreConstants.INITIAL_STATE, action);
      }
    }

    if(action.type === StoreActionTypes.SessionState){
      return reducer(onStoreInit(), action);
    }
    
    if (
      action.type === LearningRecordTabActionTypes.UpdateTabStateSuccess ||
      action.type === LearningRecordTabActionTypes.UpdateTabState ||
      action.type === LearningRecordTabActionTypes.SetTabStateSuccess ||
      action.type === SkillsCheckTabActionTypes.UpdatePanelState ||
      action.type === SkillsCheckTabActionTypes.UpdatePanelStateSuccess ||
      action.type === SkillsCheckTabActionTypes.UpdateSkillsCheckPanelState ||
      action.type === SkillsCheckTabActionTypes.UpdateAttemptPanelState ||
      action.type ===
        SkillsCheckTabActionTypes.UpdateAttemptPanelStateSuccess ||
      action.type === SkillsCheckTabActionTypes.GetSkillsCheckResultSuccess ||
      action.type === LearningPlanActionTypes.UpdatePanelState ||
      action.type === LearningPlanActionTypes.UpdatePanelStateSuccess ||
      action.type === LearningPlanActionTypes.SetPanelStateSuccess ||
      action.type === LearningPlanActionTypes.UpdateAllowPopUpSuccess ||
      action.type === CentreActionTypes.SetCentreData ||
      action.type === CentreActionTypes.SetCentreDataSuccess ||
      action.type === NavigationStateActionTypes.StoreNavigationSession ||
      action.type === OrganisationActionTypes.SetOrganisationDetails || 
      action.type === EditLearnerActionTypes.SetEditLearnerSuccess ||
      action.type === OrganisationActionTypes.SetOrganisationDetails ||
      action.type === TutorEditActionTypes.SetTutorProfileSuccess ||
      action.type === LearnerOfflineActivityTypes.StoreOfflineActivityNavigationSession || 
      action.type === DigLitSelfAssessmentActionTypes.SetDigLitStateSuccess ||
      action.type === LearnerActionTypes.SetMultipleLearnerIdsSuccess ||
      action.type === UserProfileActionTypes.SetUserProfile
    ) {
      onStoreUpdate(state);
    }

    return reducer(state, action);
  };
}

export function onStoreInit(): StoreState {
  const stateStorage = sessionStorage.getItem(StoreConstants.STATE_STORAGE_KEY);

  let result = stateStorage
    ? JSON.parse(stateStorage)
    : StoreConstants.INITIAL_STATE;
    
  return result;
}

export function onStoreUpdate(state: StoreState): void {

  sessionStorage.setItem(
    StoreConstants.STATE_STORAGE_KEY,
    JSON.stringify(state)
  );
}
